import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const ErrorMessage = styled.div`
    margin-top: ${SPACING.SMALL};
    width: 100%;
    min-height: ${SPACING.SMALL_4};
`;
